import { cadastar_o_tipo_da_solicitacao } from "./cadastrar-o-tipo-da-solicitacao";
import { cadastrar_a_solicitacao } from "./cadastrar-a-solicitacao";
import { responder_a_solicitacao } from "./responder-a-solicitacao";
import { consultar_estatistica_solicitacao } from "./estatistica-solicitacao";

const solicitacoes_de_servicos_de_uma_unidade_para_outra = [
  ...cadastar_o_tipo_da_solicitacao,
  ...cadastrar_a_solicitacao,
  ...responder_a_solicitacao,
  ...consultar_estatistica_solicitacao,
];

export { solicitacoes_de_servicos_de_uma_unidade_para_outra };
